var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIndustryWindow = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 3C8.25 2.17157 7.57843 1.5 6.75 1.5H3C2.17157 1.5 1.5 2.17157 1.5 3V21C1.5 21.8284 2.17157 22.5 3 22.5H21C21.8284 22.5 22.5 21.8284 22.5 21V6.78348C22.5 6.15937 21.7822 5.8083 21.2895 6.19146L15.75 10.5V7.32464C15.75 6.74167 15.114 6.38159 14.6141 6.68152L8.25 10.5V3ZM6.75 3H3V21H21V8.25L15.4605 12.5585C14.9678 12.9417 14.25 12.5906 14.25 11.9665V8.7L7.88587 12.5185C7.38598 12.8184 6.75 12.4583 6.75 11.8754V3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.25 15C14.25 14.5858 13.9142 14.25 13.5 14.25H10.5C10.0858 14.25 9.75 14.5858 9.75 15V18C9.75 18.4142 10.0858 18.75 10.5 18.75H13.5C13.9142 18.75 14.25 18.4142 14.25 18V15ZM12.75 15.75H11.25V17.25H12.75V15.75Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 15C8.25 14.5858 7.91421 14.25 7.5 14.25H4.5C4.08579 14.25 3.75 14.5858 3.75 15V18C3.75 18.4142 4.08579 18.75 4.5 18.75H7.5C7.91421 18.75 8.25 18.4142 8.25 18V15ZM6.75 15.75H5.25V17.25H6.75V15.75Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.25 15C20.25 14.5858 19.9142 14.25 19.5 14.25H16.5C16.0858 14.25 15.75 14.5858 15.75 15V18C15.75 18.4142 16.0858 18.75 16.5 18.75H19.5C19.9142 18.75 20.25 18.4142 20.25 18V15ZM18.75 15.75H17.25V17.25H18.75V15.75Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIndustryWindow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/industry-window.ddcc894fabe5d1a0c944696739c93f2f.svg";